import { render, staticRenderFns } from "./BookPage.vue?vue&type=template&id=c013ef88"
import script from "./BookPage.vue?vue&type=script&lang=js"
export * from "./BookPage.vue?vue&type=script&lang=js"
import style0 from "./BookPage.vue?vue&type=style&index=0&id=c013ef88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports